// Pond Data Manager - pond-data-manager.js
var PondDataManager = (function() {
  var STORAGE_KEY = 'pond_planning_projects';
  var ACTIVE_PROJECT_KEY = 'pond_active_project_id';
function isLoggedIn() {
  // Check if Shopify customer is logged in
  // This checks for the global Shopify customer object
  if (typeof window !== 'undefined' && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
    return window.ShopifyAnalytics.meta.page.customerId !== null && window.ShopifyAnalytics.meta.page.customerId !== undefined;
  }
  
  // Fallback: check for customer account indicator in page
  if (typeof document !== 'undefined') {
    var accountLink = document.querySelector('a[href*="/account"]');
    var logoutLink = document.querySelector('a[href*="/account/logout"]');
    return !!(logoutLink); // If logout link exists, user is logged in
  }
  
  // Default to false if can't determine
  return false;
}

// Check if user can save (must be logged in)
function canSave() {
  return isLoggedIn();
}
  // Check if user can save (must be logged in)
  function canSave() {
    return isLoggedIn();
  }
  
  // Manual save (user-initiated)
function saveProject(projectData, projectName) {
  if (!canSave()) {
    return Promise.reject({
      code: 'NOT_LOGGED_IN',
      message: 'User must be logged in to save projects'
    });
  }
  
  var projects = getAllProjects();
  var projectId;
  var isUpdate = false;
  
  // Check if updating existing project by name
  var activeId = getActiveProjectId();
  if (activeId && projects[activeId] && projects[activeId].project.name === projectName) {
    // Updating active project with same name
    projectId = activeId;
    isUpdate = true;
  } else {
    // Check all projects for name match
    for (var key in projects) {
      if (projects[key].project && projects[key].project.name === projectName) {
        projectId = key;
        isUpdate = true;
        break;
      }
    }
  }
  
  // Generate new ID only if not updating
  if (!projectId) {
    projectId = generateUUID();
  }
  
  if (!projectData.project) {
    projectData.project = {};
  }
  
  projectData.project.id = projectId;
  projectData.project.name = projectName || 'Untitled Project';
  projectData.project.modified = new Date().toISOString();
  
  // Only set created date for new projects
  if (!isUpdate || !projectData.project.created) {
    projectData.project.created = projectData.project.modified;
  }
  
  projects[projectId] = projectData;
  
  console.log('[PondDataManager] Saving project:', projectName, isUpdate ? '(update)' : '(new)', 'ID:', projectId);
  
  // For now, save to localStorage (Phase 2 will add Shopify sync)
  var result = saveProjectsToLocalStorage(projects);
  
  // Set active project after successful save
if (result) {
  setActiveProject(projectId);
}
  return result;
}
    
  function getActiveProjectId() {
    return localStorage.getItem(ACTIVE_PROJECT_KEY);
  }
  
  function setActiveProject(projectId) {
    localStorage.setItem(ACTIVE_PROJECT_KEY, projectId);
  }
  
  function getAllProjects() {
    if (!isLoggedIn()) {
      return {}; // No projects if not logged in
    }
    
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      console.error('Failed to parse projects from localStorage', e);
      return {};
    }
  }
  
  function saveProjectsToLocalStorage(projects) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(projects));
      return Promise.resolve(true);
    } catch (e) {
      console.error('Failed to save to localStorage', e);
      return Promise.reject(e);
    }
  }
  
  function generateUUID() {
    return 'project_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }
  
  // Clear all data on logout
  function clearOnLogout() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(ACTIVE_PROJECT_KEY);
  }
  
  // Draft management (for non-logged-in users)
  var DRAFT_KEY = 'pond_calculator_draft';
  
  function saveDraft(projectData) {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify(projectData));
      return true;
    } catch (e) {
      console.error('Failed to save draft', e);
      return false;
    }
  }
  
  function getDraft() {
    try {
      var draft = localStorage.getItem(DRAFT_KEY);
      return draft ? JSON.parse(draft) : null;
    } catch (e) {
      console.error('Failed to get draft', e);
      return null;
    }
  }
  
  function clearDraft() {
    try {
      localStorage.removeItem(DRAFT_KEY);
      return true;
    } catch (e) {
      console.error('Failed to clear draft', e);
      return false;
    }
  }
  
  // Public API
  return {
    // Auth checks
    isLoggedIn: isLoggedIn,
    canSave: canSave,
    
    // Project management
    getAllProjects: getAllProjects,
    getActiveProject: function() {
      var projects = getAllProjects();
      var activeId = getActiveProjectId();
      return activeId ? projects[activeId] : null;
    },
    saveProject: saveProject,        // Manual save (user clicks button)

    deleteProject: function(projectId) {
      var projects = getAllProjects();
      delete projects[projectId];
      return saveProjectsToLocalStorage(projects);
    },
    setActiveProject: setActiveProject,
    
    // Session management
    clearOnLogout: clearOnLogout,
    
    // Draft management
    saveDraft: saveDraft,
    getDraft: getDraft,
    clearDraft: clearDraft,
    
    // Export/Import
    exportProject: function(projectId) {
      var projects = getAllProjects();
      var project = projects[projectId];
      
      if (!project) return null;
      
      return {
        type: 'pond_planning_export',
        version: '1.0',
        exported: new Date().toISOString(),
        data: project
      };
    },
    importProject: function(exportData) {
      if (!canSave()) {
        return Promise.reject({
          code: 'NOT_LOGGED_IN',
          message: 'Must be logged in to import projects'
        });
      }
      
      if (exportData.type !== 'pond_planning_export') {
        throw new Error('Invalid export format');
      }
      
      var newProjectData = JSON.parse(JSON.stringify(exportData.data));
      newProjectData.project.id = generateUUID();
      newProjectData.project.name += ' (imported)';
      newProjectData.project.created = new Date().toISOString();
      newProjectData.project.modified = newProjectData.project.created;
      
      return saveProject(newProjectData, newProjectData.project.name);
    }
  };
})();